export interface UserProfile {
  name: string;
  email: string;
  phone: string;
  avatar: string;
  group: 'science' | 'humanities' | 'commerce';
  optional: string | null;
  class: string;
  institution: string;
  board: string;
  careerGoal: string;
  dreamUniversity: string;
}

export const currentUser: UserProfile = {
  name: 'রাহুল আহমেদ',
  email: 'rahul.ahmed@example.com',
  phone: '01712345678',
  avatar: '',
  group: 'science',
  optional: 'কৃষি শিক্ষা',
  class: 'এসএসসি ২০২৭',
  institution: 'ঢাকা কলেজিয়েট স্কুল',
  board: 'ঢাকা',
  careerGoal: 'সফটওয়্যার ইঞ্জিনিয়ার',
  dreamUniversity: 'বুয়েট',
};

export const userStats = {
  totalCourses: 24,
  successRate: 12,
  quizAverage: 89,
  streakDays: 15,
  courseCompletion: 65,
};

export const userCourses = [
  {
    id: 1,
    title: 'বাংলা ১ম পত্র',
    subtitle: 'SSC 2027',
    progress: 78,
    totalLessons: 45,
    completedLessons: 35,
    color: 'from-indigo-500 to-blue-600',
  },
  {
    id: 2,
    title: 'গণিত',
    subtitle: 'SSC 2027',
    progress: 45,
    totalLessons: 60,
    completedLessons: 27,
    color: 'from-emerald-500 to-teal-600',
  },
  {
    id: 3,
    title: 'পদার্থবিজ্ঞান',
    subtitle: 'SSC 2027',
    progress: 62,
    totalLessons: 40,
    completedLessons: 25,
    color: 'from-violet-500 to-purple-600',
  },
  {
    id: 4,
    title: 'রসায়ন',
    subtitle: 'SSC 2027',
    progress: 30,
    totalLessons: 35,
    completedLessons: 11,
    color: 'from-amber-500 to-orange-600',
  },
  {
    id: 5,
    title: 'জীববিজ্ঞান',
    subtitle: 'SSC 2027',
    progress: 55,
    totalLessons: 38,
    completedLessons: 21,
    color: 'from-rose-500 to-pink-600',
  },
  {
    id: 6,
    title: 'ইংরেজি ১ম পত্র',
    subtitle: 'SSC 2027',
    progress: 80,
    totalLessons: 50,
    completedLessons: 40,
    color: 'from-cyan-500 to-sky-600',
  },
];
